<template>
  <div class="playercontrols">
    <div class="playercontrols-progress">
      <div class="playercontrols-progress-bar" :style="barStyle"></div>
    </div>
    <button @click="$emit('toggle')">
      <img v-if="!playing" src="@/assets/play.svg" alt="" width="24" height="24">
      <img v-else src="@/assets/pause.svg" alt="" width="24" height="24">
    </button>
    <button @click="$emit('reset')">
      <img src="@/assets/restart.svg" alt="" width="24" height="24">
    </button>
  </div>
</template>

<script>
export default {
  props: {
    playing: Boolean,
    progress: Number
  },
  computed: {
    barStyle() {
      return {
        width: (this.progress * 100) + '%'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.playercontrols {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  display: flex;
  align-items: center;
  padding-top: 20px;

  &-progress {
    width: 100%;
    position: absolute;
    top: 10px;
    left: 0;

    &-bar {
      height: 6px;
      width: 0;
      background-color: #fff;
    }
  }

  button {
    cursor: pointer;
    appearance: none;
    border: none;
    background: none;
  }
}
</style>